import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTriangleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.96646 16.8716C4.67426 17.3716 5.03488 18 5.61399 18L18.386 18C18.9651 18 19.3257 17.3716 19.0335 16.8716L12.7339 6.09215C12.4057 5.53066 11.5943 5.53066 11.2661 6.09215L4.96646 16.8716ZM5.61399 19.5C3.87665 19.5 2.7948 17.6147 3.6714 16.1147L9.97107 5.3353C10.8783 3.78294 13.1217 3.78294 14.0289 5.3353L20.3286 16.1147C21.2052 17.6147 20.1233 19.5 18.386 19.5L5.61399 19.5Z",
		fill: "currentColor"
	})
});
export { SvgIconTriangleUp as ReactComponent };
